import { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { ADMIN_ENDPOINTS, adminFetch } from '../config';
import { useAdmin } from './AdminContext';
import './Admin.css';

function getRedirectFrom(state) {
  const from = state?.from;
  if (!from || typeof from.pathname !== 'string') return '/admin';
  return from.pathname + (from.search ?? '') + (from.hash ?? '');
}

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, login } = useAdmin();
  const redirectTo = getRedirectFrom(location.state);

  if (user) return <Navigate to={redirectTo} replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await adminFetch(ADMIN_ENDPOINTS.login, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (data.success) {
        login(data.username);
        navigate(redirectTo, { replace: true });
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{ background: 'var(--admin-surface)', padding: '2.5rem', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.3)', width: '100%', maxWidth: 380 }}>
        <h1 style={{ margin: '0 0 1.5rem 0', fontSize: '1.5rem', textAlign: 'center', color: '#6CFF6C' }}>Portfolio Admin</h1>
        {error && <div style={{ background: '#e74c3c33', color: '#e74c3c', padding: '0.75rem', borderRadius: 8, marginBottom: '1rem', fontSize: '0.9rem' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="btn" style={{ width: '100%', padding: '0.9rem' }} disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
